export default class TimesheetTimeStringDetailsModel {
  constructor({
    startTime,
    endTime,
    payOptionType = '',
    breaks = '',
    abbreviated = false,
  } = {}) {
    /**
     * @type {String}
     */
    this.startTime = startTime
    /**
     * @type {String}
     */
    this.endTime = endTime
    /**
     * @type {String}
     */
    this.payOptionType = payOptionType
    /**
     * @type {Number}
     */
    this.breaks = breaks
    /**
     * Will abbreviate the text where possible
     * @type {Boolean}
     */
    this.abbreviated = abbreviated
  }
}
